import Skeleton from '@app.components/Skeleton'
import { AD_CODE_ID } from '@app.feature/ad/constants/adCode'
import useGetAdByPlacementCodeAndCurrentTime from '@app.feature/ad/hooks/useGetAdByPlacementCodeAndCurrentTime'
import CoverLetterSearchBannerDesktop, {
  COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE,
} from './CoverLetterSearchBanner.desktop'

const CoverLetterSearchBannerStatusDesktop = () => {
  const { ad, loading, error } = useGetAdByPlacementCodeAndCurrentTime({
    code: AD_CODE_ID.COVER_LETTER_SEARCH.PC,
  })

  if (loading) {
    return (
      <Skeleton
        width={COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.width}
        height={COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.height}
      />
    )
  }

  if (!ad || error) {
    return null
  }

  return <CoverLetterSearchBannerDesktop ad={ad} />
}

export default CoverLetterSearchBannerStatusDesktop
